module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/as3613-8149f33369caf71ffcc369a639362cd6.jpg";